export enum PlanPeriodEnum {
  month = 'month',
  year = 'year',
}

export enum PlanNameEnum {
  starter = 'Starter',
  basic = 'Basic',
  premium = 'Premium',
}
export enum PlanNamePackage {
  'Gold' = 'Gold',
  'Platinum' = 'Platinum',
  'Silver' = 'Silver',
}
